<template>
  <v-card class="mb-3" :elevation="elevation">
    <v-card-text>
      <div class="d-flex justify-space-between">
        <div v-if="source.source.toLowerCase() == 'twitter'">
          <v-icon size="16" color="#1DA1F2">mdi-twitter</v-icon>
          <a v-if="source.author" :href="source.url" target="_blank">{{
            source.author
          }}</a>
        </div>
        <div v-else-if="source.source.toLowerCase().startsWith('file')">
          <v-icon size="16" color="#1DA1F2">mdi-description</v-icon>
          <a v-if="source.title" :href="linkUrl" target="_blank">{{
            source.title
          }}</a>
          <a v-else :href="linkUrl" target="_blank">{{ source.source }}</a>
          <v-btn
            :href="`/datasets/${datasetUid}/document/${id}`"
            target="_blank"
            icon
            height="16"
          >
            <v-icon size="16">mdi-text-box-search</v-icon>
          </v-btn>
        </div>
        <div v-if="source.source.toLowerCase() == 'news'">
          <v-icon size="16" class="pr-1">mdi-text-box-multiple</v-icon>
          <a v-if="source.title" :href="source.url" target="_blank">{{
            source.title.length > 90
              ? source.title.substring(0, 90) + "..."
              : source.title
          }}</a>
          <a v-else-if="source.url" :href="source.url" target="_blank">{{
            source.url.length > 90
              ? source.url.substring(0, 90) + "..."
              : source.url
          }}</a>
        </div>
        <div class="text--secondary">
          <v-icon size="16">event</v-icon>
          {{ source.creation_time }}
        </div>
      </div>
      <div v-if="snippets" class="body text-justify mt-2">
        <span v-for="(s, index) in snippets" :key="index">
          &lt;&lt;{{ s }}&gt;&gt;
        </span>
      </div>
      <div v-else class="body text-justify">
        {{ content }}
      </div>
      <div v-if="source.source.toLowerCase() == 'twitter'" class="body-2 mt-1">
        <span>
          <v-icon size="14" class="pb-1">favorite</v-icon>
          {{ source.like_count }}
        </span>
        <span>
          <v-icon size="14" class="pb-1">cached</v-icon>
          {{ source.share_count }}
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    copraUrl: { type: String, default: process.env.VUE_APP_COPRA_SERVER_URL },
    id: {
      type: String,
    },
    elevation:{
      type: Number,
      default: 1
    },
    source: {
      type: Object,
      default: () => {},
    },
    hits: {
      type: Object,
      default: () => [],
    },
  },
  computed: {
    content() {
      if (
        Array.isArray(this.source.content) &&
        this.source.content.length > 0
      ) {
        return this.source.content[0];
      } else {
        return this.source.content;
      }
    },
    snippets() {
      return this.hits["metadata.sentences"].hits.hits.map((h) => {
        return h._source.sent;
      });
    },
    linkUrl() {
      if (this.source.url.startsWith("http")) {
        return this.source.url;
      }
      return `${this.copraUrl}/files/download?p=${this.source.url}`;
    },
    datasetUid() {
      return this.$route.params.datasetUid;
    },
  },
};
</script>

<style>
</style>